import { render, staticRenderFns } from "./ride.vue?vue&type=template&id=c42e84f2&scoped=true&lang=pug&"
import script from "./ride.vue?vue&type=script&lang=js&"
export * from "./ride.vue?vue&type=script&lang=js&"
import style0 from "./ride.vue?vue&type=style&index=0&id=c42e84f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42e84f2",
  null
  
)

export default component.exports